import type { ReactNode } from 'react'

import { ChatView } from './chat.view'

export const ChatPage = (): ReactNode => (
  <div className="chat-page h-full overflow-hidden">
    <ChatView />
  </div>
)
